module.exports = __webpack_public_path__ + "img/truck.94e76c27.svg";